import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { Column, SummaryTable, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { GetPayoutsSummaryWidgetTID } from './PayoutsSummaryWidget';
import styles from './PayoutsSummaryWidget.module.scss';
export const GetPayoutsSummaryTableTID = (parentTestId)=>getTestIds(parentTestId);
export const PayoutsSummaryTable = (param)=>{
    let { data, testId } = param;
    const { t: tableTexts } = useLocaleKeys('home.dashboard.payoutsSummaryWidget');
    const { PayoutsSummaryWidgetTID } = useMemo(()=>GetPayoutsSummaryWidgetTID(), []);
    const { PayoutsSummaryTableTID } = useMemo(()=>GetPayoutsSummaryTableTID(testId), [
        testId
    ]);
    const items = data.mapPayouts((payout)=>({
            id: payout.uniqueKey(),
            date: payout.formattedDate(),
            amount: payout.amount(),
            status: payout.statusText(tableTexts.statusLabels),
            href: payout.redirectURL()
        }));
    const columns = [
        // WHY: a scheduled payout's date carries the future marker, so it stays the model's text.
        {
            type: 'text',
            name: 'date',
            header: tableTexts.tableHeaders.date(),
            width: {
                initial: 150,
                min: 100
            }
        },
        {
            type: 'money',
            name: 'amount',
            header: tableTexts.tableHeaders.amount(),
            width: {
                initial: 150,
                min: 100
            },
            hAlign: 'end'
        },
        {
            type: 'badge',
            name: 'status',
            header: tableTexts.tableHeaders.status(),
            width: {
                initial: 150,
                min: 80
            },
            hAlign: 'end',
            useColor: (label)=>label === tableTexts.statusLabels.paid() ? 'success' : 'default'
        }
    ];
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 0,
        className: styles.table,
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx(SummaryTable, {
                columns: columns,
                items: items,
                getRowId: (row)=>row.id,
                rowHref: (row)=>row.href,
                testId: PayoutsSummaryTableTID.Summary()
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: 0,
                className: styles.viewMore,
                children: [
                    /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'view_more_payouts'
                        },
                        as: NavLink,
                        to: routes.payoutsDashboard,
                        testId: PayoutsSummaryWidgetTID.ViewMore(),
                        underline: "none",
                        weight: "normal",
                        children: tableTexts.viewMore()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: tableTexts.futurePayoutsDisclaimer()
                    })
                ]
            })
        ]
    });
};
